import { VisualisationContextProps } from 'widgets/supportVisualisation/Content/VisualisationContentProps';
import React, { useState } from 'react';
import 'widgets/supportVisualisation/Content/StreamedData/SupportVisualisationStreamedData.scss';
import { Button, Menu } from '@instinet-analytics/semantic-ui-components';

import '../../SupportVisualisationMenu.scss';
import { StreamedDataKey } from 'streamsState/store/streamedData/StreamedDataState';
import JsonPanel from 'utils/components/JsonPanel/JsonPanel';
import { useDispatch } from 'store/hooks';
import { createReplaceAllStreamDataPayload } from 'streamsState/store/streamedData/actions';

export default function SupportVisualisationStreamedData(
    props: VisualisationContextProps
) {
    const { state, width, height } = props;

    const style = { width, height };
    const jsonStyle = { height, overflow: 'auto', flex: 1 };

    const [currentKey, setCurrentKey] = useState<StreamedDataKey | undefined>();
    const [currentStreamKey, setCurrentStreamKey] = useState<
        string | undefined
    >();
    const dispatch = useDispatch();

    const streamedData = state?.state.streams.data;
    const corpActions = state?.state.widgets.data.corporateActions;
    if (!streamedData && !corpActions) {
        return <div>None In State</div>;
    }

    const data = { ...streamedData, corpActions } as unknown as Record<
        string,
        Record<string, unknown>
    >;
    const streamedDataKeys = Object.keys(data).filter(
        (s) => Object.keys(data[s]).length > 0
    );
    const currentKeyStreams = data && currentKey ? data[currentKey] : {};
    const currentKeyStreamKeys: string[] = Object.keys(currentKeyStreams) ?? [];

    const onClickReplace = () => {
        streamedData &&
            dispatch(createReplaceAllStreamDataPayload(streamedData));
    };

    const json = currentStreamKey
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (currentKeyStreams as any)[currentStreamKey]
        : undefined;

    return (
        <div
            className="SupportVisualisationStreamedData streamed-data"
            style={style}
        >
            <div>
                <Menu
                    pointing
                    vertical
                    className="SupportVisualisationMenu streamedDataKeys"
                >
                    {streamedDataKeys.map((u) => (
                        <KeyLink
                            key={u}
                            streamedDataKey={u as StreamedDataKey}
                        />
                    ))}
                    <Button
                        primary
                        tiny
                        className="replace-btn"
                        onClick={onClickReplace}
                    >
                        Replace
                    </Button>
                </Menu>
            </div>
            <div>
                <Menu
                    pointing
                    vertical
                    className="SupportVisualisationMenu uids-menu"
                >
                    {currentKeyStreamKeys.map((k) => (
                        <UidLink key={k} streamKey={k} />
                    ))}
                </Menu>
            </div>
            {json && (
                <div style={jsonStyle}>
                    <JsonPanel data={json} />
                </div>
            )}
        </div>
    );

    function onChangeCurrentKey(nextKey: StreamedDataKey) {
        setCurrentKey(nextKey);
        setCurrentStreamKey(undefined);
    }

    function onChangeCurrentStreamKey(nextStreamKey: string) {
        setCurrentStreamKey(nextStreamKey);
    }

    function KeyLink(props: { streamedDataKey: StreamedDataKey }) {
        const { streamedDataKey } = props;
        return (
            <Menu.Item
                active={streamedDataKey === currentKey}
                onClick={() => onChangeCurrentKey(streamedDataKey)}
            >
                {streamedDataKey}
            </Menu.Item>
        );
    }
    function UidLink(props: { streamKey: string }) {
        const { streamKey } = props;
        return (
            <Menu.Item
                active={streamKey === currentStreamKey}
                onClick={() => onChangeCurrentStreamKey(streamKey)}
            >
                {streamKey}
            </Menu.Item>
        );
    }
}
